import { defineStore } from 'pinia';
import { ref } from 'vue';

const useDialogStore = defineStore('dialog', () => {
    // ID of special case partner to delete
    const showEditOrderDialog = ref<boolean>(false);
    const showConfirmationDialog = ref<number>(0);
    const showUnauthorizedAccessDialog = ref<boolean>(false);
    const showAddSpecialCaseDialog = ref<boolean>(false);
    const showDownloadDocumentsDialog = ref<boolean>(false);
    const showDocumentUnavailableDialog = ref<boolean>(false);
    const showOrderEditedDialog = ref<boolean>(false);
    const orderEditedByUser = ref<string>('');
    const pendingEditedOrderIds = ref<number[]>([]);

    const queueOrderEditedDialog = (orderId: number) => {
        pendingEditedOrderIds.value = Array.from(
            new Set([...pendingEditedOrderIds.value, orderId])
        );
        showOrderEditedDialog.value = true;
    };

    const closeOrderEditedDialog = () => {
        showOrderEditedDialog.value = false;
    };

    const consumePendingEditedOrderIds = () => {
        const ids = [...pendingEditedOrderIds.value];
        pendingEditedOrderIds.value = [];
        return ids;
    };

    return {
        showEditOrderDialog,
        showConfirmationDialog,
        showUnauthorizedAccessDialog,
        showAddSpecialCaseDialog,
        showDownloadDocumentsDialog,
        showDocumentUnavailableDialog,
        showOrderEditedDialog,
        orderEditedByUser,
        pendingEditedOrderIds,
        queueOrderEditedDialog,
        closeOrderEditedDialog,
        consumePendingEditedOrderIds,
    };
});

export default useDialogStore;
